import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../styles/Header.css'; 
import logoImage from '../assets/logos/Spirit Falls Logo MainBW.png';
import logoCreamsicle from '../assets/logos/Spirit Falls Logo Creamsicle.png';
import logoGreenGrey from '../assets/logos/Spirit Falls Logo GreenGrey.png';
import logoHalloween from '../assets/logos/Spirit Falls Logo Halloween.png';
import logoHoney from '../assets/logos/Spirit Falls Logo Honey.png';
import logoMonoPink from '../assets/logos/Spirit Falls Logo MonoPink.png';
import logoMushroom from '../assets/logos/Spirit Falls Logo Mushroom.png';
import logoOil from '../assets/logos/Spirit Falls Logo Oil.png';
import logoPastelBrooke from '../assets/logos/Spirit Falls Logo PastelBrooke.png';
import logoPastelLuna from '../assets/logos/Spirit Falls Logo PastelLuna.png';
import logoRedPurple from '../assets/logos/Spirit Falls Logo RedPurple.png';
import logoSpiritOcean from '../assets/logos/Spirit Falls Logo SpiritOcean.png';
import logoWanda from '../assets/logos/Spirit Falls Logo Wanda.png';
import logoMidnight from '../assets/logos/Spirit Falls Midgnight.png'; 
import homeDefault from '../assets/site_assets/Top Bar/Top Bar 1.png';
import homeActive from '../assets/site_assets/Top Bar/Top Bar 1 Active.png';
import chaptersDefault from '../assets/site_assets/Top Bar/Top Bar 2.png';
import chaptersActive from '../assets/site_assets/Top Bar/Top Bar 2 Active.png';
import aboutDefault from '../assets/site_assets/Top Bar/Top Bar 3.png';
import aboutActive from '../assets/site_assets/Top Bar/Top Bar 3 Active.png';
import supportDefault from '../assets/site_assets/Top Bar/Top Bar 4.png';
import supportActive from '../assets/site_assets/Top Bar/Top Bar 4 Active.png';

const navItems = [
  {
    to: '/',
    label: 'Home',
    icon: homeDefault,
    iconActive: homeActive,
    exact: true
  },
  {
    to: '/chapters',
    label: 'Chapters',
    icon: chaptersDefault,
    iconActive: chaptersActive
  },
  {
    to: '/about',
    label: 'About',
    icon: aboutDefault,
    iconActive: aboutActive
  },
  {
    to: 'https://www.patreon.com/cw/smappy',
    label: 'Support Me',
    icon: supportDefault,
    iconActive: supportActive,
    external: true
  },
];

// Array of alternative logos (excluding MainBW)
const alternativeLogos = [
  logoCreamsicle,
  logoGreenGrey,
  logoHalloween,
  logoHoney,
  logoMonoPink,
  logoMushroom,
  logoOil,
  logoPastelBrooke,
  logoPastelLuna,
  logoRedPurple,
  logoSpiritOcean,
  logoWanda,
  logoMidnight
];

function Header({ showNavigation = true, hideLogoInViewer = false }) {
  // Pick a random colored logo on mount
  const [defaultLogo] = useState(() => {
    const randomIndex = Math.floor(Math.random() * alternativeLogos.length);
    return alternativeLogos[randomIndex];
  });
  const [isHovered, setIsHovered] = useState(false);
  
  const handleLogoMouseEnter = () => {
    setIsHovered(true);
  };
  
  const handleLogoMouseLeave = () => {
    setIsHovered(false);
  };
  
  return (
    <>
      {/* Logo Container - Positioned Separately - Hidden in viewer */}
      {!hideLogoInViewer && (
        <div className="logo-container">
          <Link 
            to="/" 
            className={`logo-link ${isHovered ? 'logo-hovered' : ''}`}
            onMouseEnter={handleLogoMouseEnter}
            onMouseLeave={handleLogoMouseLeave}
          >
            <img 
              src={defaultLogo} 
              alt="Spirit Falls Logo" 
              className="logo-image logo-image-color" 
            />
            <img 
              src={logoImage} 
              alt="Spirit Falls Logo" 
              className="logo-image logo-image-white" 
            />
          </Link>
        </div>
      )}

      {/* Navigation Header */}
      <header className={`header${showNavigation ? '' : ' header-compact'}`}>
        {showNavigation && (
          <nav className="navigation">
            {navItems.map(item => (
              item.external ? (
                <a
                  key={item.to}
                  href={item.to}
                  className="header-nav-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="header-nav-icon-wrapper">
                    <img
                      src={item.icon}
                      alt=""
                      aria-hidden="true"
                      className="header-nav-icon header-nav-icon-default"
                    />
                    <img
                      src={item.iconActive}
                      alt=""
                      aria-hidden="true"
                      className="header-nav-icon header-nav-icon-active"
                    />
                  </span>
                  <span className="sr-only">{item.label}</span>
                </a>
              ) : (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className="header-nav-button"
                >
                  {({ isActive, isPending }) => (
                    <>
                      <span className="header-nav-icon-wrapper">
                        <img
                          src={item.icon}
                          alt=""
                          aria-hidden="true"
                          className="header-nav-icon header-nav-icon-default"
                        />
                        <img
                          src={item.iconActive}
                          alt=""
                          aria-hidden="true"
                          className="header-nav-icon header-nav-icon-active"
                        />
                      </span>
                      <span className="sr-only">{item.label}</span>
                    </>
                  )}
                </NavLink>
              )
            ))}
          </nav>
        )}
      </header>
    </>
  );
}

export default Header; 